import React, { FC } from "react";
import { Form, InputGroup, Row, Col } from 'react-bootstrap';
import { useState } from 'react';

export enum FormOption {
    Issue = 'issue',
    Suggestion = 'suggestion'
}

export enum ContactChoices {
    Email = 'Email',
    Phone = 'Phone',
    None = 'No thanks'
}

interface ContactOptionsProps {
    initialEmail: string;
    formOption: FormOption,
    updateContactChoice: (choice: ContactChoices) => void;
    updateContactInfo: (info: string) => void;
    errorMsgs?: object;
}

const ContactOptions: FC<ContactOptionsProps> = ({initialEmail, formOption, updateContactChoice, updateContactInfo, errorMsgs}) => {
    const options = Object.values(ContactChoices);
    if (formOption === FormOption.Issue) options.pop();

    const [selectedOption, setSelectedOption] = useState(ContactChoices.Email);
    const [contactInfo, setContactInfo] = useState<string>(initialEmail);

    const handleContactChoiceChange = (option: ContactChoices) => {
        setContactInfo("");
        setSelectedOption(option);
        updateContactChoice(option);
        updateContactInfo("");
    };

    const handleContactInfoChange = (info: string) => {
        setContactInfo(info);
        updateContactInfo(info);
    }

    return (
        <Form.Group controlId="contactOptions" className="mt-3">
            <Row className="mb-3">
                <Col>
                    <Form.Label className="fw-bold">
                        Would you like to be contacted regarding this error?<span className="required">*</span>
                    </Form.Label>

                    {options.map(option => <Form.Check type={"radio"} label={option} id={option} onClick={() => handleContactChoiceChange(option)} checked={option === selectedOption} />)}
                </Col>

                <Col xs={6}>
                    {selectedOption !== ContactChoices.None &&
                        <Form.Label className="fw-bold">
                            {selectedOption === ContactChoices.Email && "Email Address"}
                            {selectedOption === ContactChoices.Phone && "Phone No."}
                        </Form.Label>
                    }
                    {selectedOption !== ContactChoices.None &&
                        <InputGroup>
                            <InputGroup.Text className="fw-bold">
                                {selectedOption === ContactChoices.Email && <i className="fa fa-envelope"></i>}
                                {selectedOption === ContactChoices.Phone && <i className="fa fa-phone"></i>}
                            </InputGroup.Text>
                            <Form.Control
                                type="text"
                                placeholder={`add ${selectedOption.toLowerCase()}...`}
                                onChange={(e) => handleContactInfoChange(e.target.value)}
                                value={contactInfo}
                            >
                            </Form.Control>
                        </InputGroup>
                    }
                    {(errorMsgs['email']) && <b className="input-error">{errorMsgs['email']}</b>}
                    {(errorMsgs['phone']) && <b className="input-error">{errorMsgs['phone']}</b>}
                </Col>
            </Row>
        </Form.Group>
    )
}

export default ContactOptions;